import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/button";
import AtriumLogo from "layouts/auth/AtriumLogo";
import { ErrorContext } from "./error-boundary";

/**
 * Not-found page. `showLogo` is for standalone renders (app-level fallback, error
 * boundary, auth layout); layouts that already show the logo omit it.
 */
const NotFound = ({ showLogo = false }) => {
  const { resetError } = useContext(ErrorContext);
  const navigate = useNavigate();

  const returnToDashboard = () => {
    resetError && resetError();
    navigate("/admin/dashboard");
  };

  return (
    <div className="mx-auto flex w-full max-w-xl flex-1 flex-col items-center justify-center gap-3 px-4 py-16 text-center">
      {showLogo && <AtriumLogo className="mb-6" />}
      <p className="text-display">404</p>
      <h1 className="text-title">Page Not Found</h1>
      <p className="text-sm text-fg-muted">
        The page you’re looking for doesn’t exist or may have been moved.
      </p>
      <Button className="mt-3" onClick={returnToDashboard}>
        Return to Dashboard
      </Button>
    </div>
  );
};

export default NotFound;
